<template>
    <div id="app">
        <div>
            <div id="nav">
                <router-link to="/">
                    <font-awesome-icon icon="home" size="lg"/>
                </router-link>
                <Backbutton/>
                <span style="display: none">
                    {{ $t('title') }}
                </span>

                <PunkteCounterTop></PunkteCounterTop>

                <div v-if="loading">
                    <font-awesome-icon icon="spinner" spin/>
                </div>
                <span class="languages">
                <span @click="changeLocale('de')" style="margin-right: 10px">
                    <img src="./assets/de.svg" title="Deutsch" alt="Deutsch"/>
                </span>
                <span @click="changeLocale('pl')" style="margin-right: 10px">
                    <img src="./assets/pl.svg" title="Polish" alt="Polish"/>
                </span>
            </span>
            </div>
            <transition name="fade" mode="out-in">
                <router-view/>
            </transition>
        </div>
        <footer>
            <router-link to="/about">Impressum</router-link>
            <router-link to="/ds">Datenschutz</router-link>
        </footer>
    </div>
</template>

<style lang="scss">
    @import "./assets/default.scss";

</style>
<style lang="scss" scoped>
    .languages img {
        width: 22px;
        cursor: pointer;
    }

    #nav {

        padding: 20px;
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        background-color: rgba(0, 0, 0, .80);
        backdrop-filter: blur(5px);
        z-index: 1002;
    }

    .fade-enter-active,
    .fade-leave-active {
        transition-duration: 0.3s;
        transition-property: opacity;
        transition-timing-function: ease;
    }

    .fade-enter,
    .fade-leave-active {
        opacity: 0
    }

    button {
        padding: 15px;
        border: 1px solid green;
        font-size: 18px;
        margin: 15px;
    }
</style>
<script type="text/babel">

    import Backbutton from "./components/Backbutton";
    import PunkteCounterTop from "./components/PunkteCounterTop";

    export default {
        name: 'home',
        components: {PunkteCounterTop, Backbutton},

        methods: {
            changeLocale(locale) {
                this.$i18n.locale = locale;
                // i18n.locale = locale;
            }
        },
        computed: {

            loading() {

                return this.$root.loading
            }
        },
    }
</script>
